@if (!(isPhonePortrait$ | async)) {
  <ng-scrollbar class="productsOnDesktop">
    <div>
      @if ((packageInShop$ | async).onePackage) {
        <h2 translate>clhriacry000208jr83ce7pek</h2>
      }
    </div>
    @if (!(isPhonePortrait$ | async)) {
      <div class="information">
        @if (matchingPackage.length) {
          <h2><span translate>clhriajii000308jr7dl026e8</span>:</h2>
        }
        @for (pack of matchingPackage; track pack) {
          <ng-container
            *ngTemplateOutlet="packageOnDesktop; context: { package: pack }"
          ></ng-container>
        }
        @if (notMatchingPackage.length) {
          <h2><span translate>clhriaohi000408jr268ifcvc</span>:</h2>
        }
        @for (pack of notMatchingPackage; track pack) {
          <ng-container
            *ngTemplateOutlet="packageOnDesktop; context: { package: pack }"
          ></ng-container>
        }
      </div>
    }
  </ng-scrollbar>
}
@if (isPhonePortrait$ | async) {
  <ng-scrollbar class="productsOnMobile">
    <div class="title">
      @if ((packageInShop$ | async).onePackage) {
        <h2 translate>clhriacry000208jr83ce7pek</h2>
      }
    </div>
    @if (matchingPackage.length) {
      <h2 class="title"><span translate>clhriajii000308jr7dl026e8</span>:</h2>
    }
    @for (pack of matchingPackage; track pack) {
      <ng-container
        *ngTemplateOutlet="packageOnMobile; context: { package: pack }"
      ></ng-container>
    }
    @if (notMatchingPackage.length) {
      <h2 class="title"><span translate>clhriaohi000408jr268ifcvc</span>:</h2>
    }
    @for (pack of notMatchingPackage; track pack) {
      <ng-container
        *ngTemplateOutlet="packageOnMobile; context: { package: pack }"
      ></ng-container>
    }
  </ng-scrollbar>
}

<div class="closeButton">
  <lib-button (click)="closeWindow.emit(true)" forceContext="common" translate
    >close</lib-button
  >
</div>
<ng-template #packageOnDesktop let-package="package">
  <div class="box">
    <div class="photoBox" (click)="openPackageDetail(package.packageId)">
      @if (package.icon) {
        <img
          [src]="package.icon | publicImageUrl: 400 : 400 | async"
          class="photo"
        />
      } @else {
        <ng-template [ngTemplateOutlet]="lack"></ng-template>
      }
      <ng-template #lack>
        <div class="photo"></div>
      </ng-template>
    </div>
    <div class="infoBox">
      <p class="name">{{ package.name }}</p>
      <div class="description"></div>
      <div class="priceAndButton">
        <span>{{ package.price | pricePicker }}</span>
        <lib-button
          (click)="openPackageDetail(package.packageId)"
          forceContext="productFront"
          translate
          >clhj5y92n000008l47ezp6yq4</lib-button
        >
      </div>
    </div>
  </div>
</ng-template>

<ng-template #packageOnMobile let-package="package">
  <div class="photoBox">
    @if (package.icon) {
      <img
        [src]="package.icon | publicImageUrl: 400 : 400 | async"
        class="photo"
      />
    } @else {
      <ng-template [ngTemplateOutlet]="lack"></ng-template>
    }
    <ng-template #lack>
      <div class="photo"></div>
    </ng-template>
    <div class="infoBox">
      <p class="name">{{ package.name }}</p>
      <span class="price">od {{ package.price | pricePicker }}</span>
      <span class="button">
        <lib-button
          (click)="openPackageDetail(package.packageId)"
          forceContext="productFront"
          translate
          >clhj5y92n000008l47ezp6yq4</lib-button
        >
      </span>
    </div>
  </div>
</ng-template>
